import { COMMON_CHUNK_NAME } from '../../../../../const/generator';
import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IParseResult,
} from '../../../../../types';

export type GantDetailsMapPluginConfig = {
  /** 包名 */
  packageName?: string;

  /** 版本 */
  packageVersion?: string;
};

const pluginFactory: BuilderComponentPluginFactory<GantDetailsMapPluginConfig> = (config?) => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IParseResult;

    // 只有当存在 detail 类型的路由时才生成 detailsMap.ts
    const detailRoutes = ir.globalRouter?.routes.filter((route) => route.fileType === 'detail');
    if (detailRoutes && detailRoutes.length > 0) {
      const detailsMapContent = `import { lazy } from 'react';

      export default {
      ${detailRoutes
        .map((route) => {
          const path = route.componentName.replace(/^\//, ''); // 移除开头的斜杠
          // @@ibom 是固定写法，表示 src 目录
          const componentPath = `@@ibom/${route.componentName}`;
          return `  '${path}': lazy(() => import('${componentPath}')),`;
        })
        .join('\n')}
      }
      `;

      next.chunks.push({
        type: ChunkType.STRING,
        fileType: FileType.TS,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: detailsMapContent,
        linkAfter: [],
        subModule: 'detailsMap',
      });
    }

    return next;
  };
  return plugin;
};

export default pluginFactory;
